import React from 'react';
import ReactTable from 'react-table'
import 'react-table/react-table.css';
import '../../../scss/_react-table-list.scss';

const DEFAULT_PAGE_SIZE = 5;
const PAGE_SIZE_OPTIONS = [5, 10, 20, 25, 50, 100];

class AnalyticsList extends React.Component {

    constructor(props) {
        super(props);
        this.state = { loading: false };
    }

    componentDidMount() {
        this.props.loadMetrics({ page: 1, onPage: 5, data: [] });
    }

    mergeParamsWithDefaults(state) {
        return {
            page: state.page + 1,
            onPage: state.pageSize || state.onPage
        };
    }


    onFetchData(state) {
        this.setState(() => ({ loading: true }), () => {
            let params = this.mergeParamsWithDefaults(state);
            this.props.loadMetrics(params).then(() => this.setState({ loading: false }));
        });
    }

    render() {
        let {
            columns,
            metrics,
            filterable = true,
            defaultPageSize = DEFAULT_PAGE_SIZE,
        } = this.props;

        if (!metrics.data || !metrics.data.length) {
            return null;
        }

        return (
            <ReactTable
                data={metrics.data}
                columns={columns}
                filterable={filterable}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                showPageSizeOptions={true}
                defaultPageSize={defaultPageSize}
                onFetchData={this.onFetchData.bind(this)}
                previousText={'Forrige'}
                nextText={'Næste'}
                pageText={'Side'}
                ofText={'af'}
                rowsText={'rækker'}
                pages={metrics.pages}
                manual
                showPagination={true}
                loadingText={'Indlæser...'}
                loading={this.state.loading}
                noDataText={'Ingen data'}
                {...this.props}
            />
        );
    }
}

export default AnalyticsList;


// WEBPACK FOOTER //
// ./web/src/components/analytics/AnalyticsList.jsx